import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { SsspListComponent } from './sssp-list/sssp-list.component';

const routes: Routes = [
  {
    path: 'sssp',
    component: SsspListComponent,
    canActivate: [
      AuthGuard
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SsspRoutingModule { }
